import { RefObject } from 'react';
import { useSelector } from 'react-redux';
import SnackbarMessage from '../../components/SnackbarMessage';
import { IRootState } from '../store/model/store.model';

const GlobalSnackbar = () => {
    const isSnackbar: boolean | RefObject<boolean> =
        useSelector((state: { user: IRootState }) => {
            const { user } = state;
            const { isSnackbar } = user;
            return isSnackbar;
        }) ?? false;
    return <>{isSnackbar && <SnackbarMessage />}</>;
};

export default GlobalSnackbar;
